import { useState } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import { DeleteIcon } from "@chakra-ui/icons";
const DeletePost = (props) => {
  const { baseUrl, token, post, forceUpdate, handleClose } = props;
  console.log("post", post);
  // let postId = post.map((post)=>{
  //    console.log("post._id" , post._id)
  //   return post._id
  //  })

  const handleDeletePost = async () => {
    const deleteUrl = `${baseUrl}/api/post/delete/${post._id}`;

    try {
      const response = await axios.delete(deleteUrl, {
        headers: {
          authorization: token,
        },
      });
      forceUpdate();
      handleClose();
      console.log("delteresponse", response);
      // const updatedPosts = posts.filter(
      //   (filter_post) => filter_post._id !== post._id
      // );
      // setPosts(updatedPosts);
      // return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
  return (
    <div className="mt-2" style={{ cursor: "pointer" }}>
      {/* <Button onClick={handleDeletePost} className="w-full">
        Delete
      </Button> */}
      <DeleteIcon onClick={handleDeletePost} style={{ cursor: "pointer" }} />
    </div>
  );
};
export default DeletePost;
